import { render, staticRenderFns } from "./CustomerExport.vue?vue&type=template&id=6b6c871a"
import script from "./CustomerExport.vue?vue&type=script&lang=js"
export * from "./CustomerExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports